// extracted by mini-css-extract-plugin
export var statItem = "_lj-1";
export var statsRow = "_lj-0";